import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { UserService } from './user.service';

interface CachedImage {
  image$: Observable<string>;
  expiresAt: Date;
}

@Injectable({
  providedIn: 'root'
})
export class ImageCacheService {

  private imageMap = new Map<string, CachedImage>();

  constructor(private _US: UserService) {}

  getImage(url: string): Observable<string> {
if (!url || !url.includes('blob')) {
    return of(url);
  }

    const cached = this.imageMap.get(url);

    // Return cached image if not expired
    if (cached && cached.expiresAt > new Date()) {
      return cached.image$;
    }

    // Remove expired cache
    this.imageMap.delete(url);


    const image$ = this._US.getSasToken(url).pipe(
      map((data: any) => {

        const decrypted = this._US.getDecryptData(data.data);

        const expiry = new Date(decrypted.expiresAt);

        // Update cache with new URL
        this.imageMap.set(url, {
          image$,
          expiresAt: expiry
        });

        return decrypted.url;
      }),
      shareReplay(1)
    );


    // Cache immediately to prevent multiple API calls
    this.imageMap.set(url, {
      image$,
      expiresAt: new Date(Date.now() + 60000)
    });


    return image$;
  }


  clearCache(url?: string) {
    if (url) {
      this.imageMap.delete(url);
    } else {
      this.imageMap.clear();
    }
  }
}